<template>
    <v-dialog v-model="showDialog" persistent max-width="350">
        <v-card>
            <v-toolbar dark color="primary lighten-1">
                <v-toolbar-title>Achtung!</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-show="invalid">
                Das bereitgestellte Geburtsdatum ist ungültig!<br>
                Bitte wählen Sie das Alter aus.
            </v-card-text>
            <v-card-text v-show="tooYoung">
                Es tut uns leid, aber der Abschluss dieses Vertrages ist erst ab {{ minAge }} Jahren möglich.
            </v-card-text>
            <v-card-actions v-if="invalid">
                <v-btn class="secondary" @click="forwardToAgeSelect">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
export default {
    name: "AgeAlertMessage",
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
        showDialog() {
            return (this.tooYoung || this.invalid) && !this.showSelect;
        },
        minAge() {
            return this.isOnlineGs ? 16 : 18;
        },
        ...mapGetters("work", {
            tooYoung: "getCookieBirthdateTooYoung",
            invalid: "getCookieBirthdateInvalid",
            showSelect: "getCookieBirthdateShowSelectNew",
            isOnlineGs: "getIsOnlineGs"
        })
    },
    methods: {
        forwardToAgeSelect() {
            this.$store.commit('work/SET_SHOW_SELECT_NEW', true);
        },
    }
}
</script>
